import { memo } from 'react';
import { View } from 'react-native';

import {
  ActionSheet,
  ActionSheetRow,
  IconAccount,
  IconCopy,
  IconInfo,
  ScrollView,
  Text,
  YStack,
  createMqStyles,
  tokens,
} from '@fhs/ui';

import { IdentifyAuthJwt } from '../../types';

type IdentifyActionSheetProps = {
  authJwts: IdentifyAuthJwt[];
  isVisible: boolean;
  onAccountSelect: () => void;
  onSelectNoneOfAbove: () => void;
  onSelect: (jwt: string) => void;
};

function IdentifyActionSheet_({
  isVisible = false,
  authJwts = [],
  onAccountSelect,
  onSelectNoneOfAbove,
  onSelect,
}: IdentifyActionSheetProps) {
  const styles = useMqStyles();
  return (
    <ActionSheet
      isVisible={isVisible}
      onClose={() => {}}
      noPanGestureDetection
      grabber={false}
      drawerProps={{ style: styles.drawer }}
    >
      <YStack style={styles.container}>
        <View style={styles.iconCopy}>
          <IconCopy size={40} />
        </View>
        <Text.Heading type="one" style={{ textAlign: 'center' }}>
          We found multiple accounts with this phone number
        </Text.Heading>
        <Text.Paragraph size="lg" style={{ textAlign: 'center' }}>
          Please select your account
        </Text.Paragraph>
      </YStack>
      <ScrollView>
        {authJwts.map((user, index) => {
          return (
            <ActionSheetRow
              key={index}
              type="accordion"
              icon={<IconAccount size={24} />}
              onPress={() => {
                onSelect(user.jwt);
                onAccountSelect();
              }}
            >
              <ActionSheetRow.Item
                firstLine={user.redactedIdentity.redactedName}
                secondLine={user.redactedIdentity.redactedEmail}
              />
            </ActionSheetRow>
          );
        })}
        <ActionSheetRow
          type="accordion"
          icon={<IconInfo size={24} />}
          onPress={() => {
            onSelectNoneOfAbove();
            onAccountSelect();
          }}
        >
          <ActionSheetRow.Item
            firstLine={'None Of The Above'}
            secondLine={'We will help you find your account.'}
          />
        </ActionSheetRow>
      </ScrollView>
    </ActionSheet>
  );
}

export const IdentifyActionSheet = memo(IdentifyActionSheet_);

const useMqStyles = createMqStyles({
  container: {
    $base: { padding: 28, maxHeight: 400, justifyContent: 'center', alignItems: 'center', gap: 8 },
    $ltDesktop: {
      padding: 16,
    },
  },
  drawer: {
    $base: { flex: 0, height: '100%' },
    $gteDesktop: {
      flex: 1,
    },
  },
  iconCopy: {
    $base: {
      height: 64,
      width: 64,
      backgroundColor: tokens.colors.$blackOpacity04,
      borderRadius: 200,
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
});
